import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

export const OtpContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;
export const OtpBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const BackContainer = styled.div`
  position: absolute;
  top: 13.5%;
  left: 3%;
  display: flex;
  align-items: center;
`;

export const GoBackText = styled.span`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  cursor: pointer;
`;

export const HeaderContainer = styled.div`
  position: absolute;
  top: 3%;
  left: 3%;

  img {
    width: 100%;
    height: auto;
  }
`;

export const OtpModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 28%;
  height: 40%;

  @media screen and (max-width: 1024px) {
    width: 60%;
    height: 30%;
    padding: 20px;
  }

  @media screen and (max-width: 1024px) and (max-height: 600px) {
    width: 60%;
    height: 60%;
    padding: 20px;
  }

  // @media screen and (max-width: 1024px) and (max-height: 600px) {
  //   width: 60%;
  //   height: 60%;
  //   padding: 20px;
  // }

  @media screen and (max-width: 820px) {
    width: 70%;
    height: 30%;
    padding: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 70%;
    height: 40%;
    padding: 20px;
  }

  @media screen and (max-width: 540px) {
    width: 70%;
    height: 45%;
    padding: 20px;
  }

  @media screen and (max-width: 430px) {
    width: 80%;
    height: 40%;
    padding: 12px;
  }

  @media screen and (max-width: 414px) {
    width: 83%;
    height: 40%;
    padding: 12px;
  }

  @media screen and (max-width: 375px) {
    width: 85%;
    height: 50%;
    padding: 10px;
    margin-top: 30px;
  }

  @media screen and (max-width: 360px) {
    width: 85%;
    height: 50%;
    padding: 10px;
    margin-top: 30px;
  }

  @media screen and (max-width: 320px) {
    width: 90%;
    height: 50%;
    padding: 10px;
    margin-top: 30px;
  }

  // @media screen and (max-width: 820px) {
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 1024px){
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 912px){
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 540px) {
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 412px){
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 1024px) {
  //   width: 80%;
  //   height: 60%;
  //   padding: 20px;
  // }

  // @media screen and (max-width: 280px) {
  //   width: 80%;
  //   height: 80%;
  //   padding: 5px;
  // }
`;

export const OtpTextContainer = styled.div`
  @media screen and (max-width: 768px) and (max-height: 1024px) {
    padding-top: 20px;
  }
`;

export const OtpInformation = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter: 0.5%;
  color: ${colors.NAVYBLUE};
  font-family: "Gt Walsheim Pro", sans-serif;
  @media screen and (max-width: 768px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }
  @media screen and (max-width: 375px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }
`;

export const OtpCreateText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.body4};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  margin-top: 15px;
  color: ${colors.DARK_GRAY};
  font-family: "Gt Walsheim Pro", sans-serif;
  @media screen and (max-width: 768px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body4};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    text-align: center;
  }
  @media screen and (max-width: 375px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body4};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    text-align: center;
  }
`;

export const OtpFormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-top: 20px;
`;

export const OtpInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  @media screen and (max-width: 375px) {
    justify-content: center;
  }
  @media screen and (max-width: 414px) {
    justify-content: center;
  }
  @media screen and (max-width: 540px) and (max-height: 720px) {
    justify-content: center;
  }
`;

export const OtpInput = styled.input.attrs({ maxLength: 1, type: "number" })`
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  border: 2px solid #ccc;
  border-radius: 8px;

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border: 1px solid black;
    outline: none;
  }

  @media screen and (max-width: 768px) {
    padding: 2px;
    margin-right: 2.5px;
  }
  @media screen and (max-width: 540px) {
    padding: 2px;
    margin-right: 5px;
  }
  @media screen and (max-width: 414px) {
    margin-right: 8px;
  }
`;

export const ResendCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 25px;
`;

export const ResendCodeText = styled.div`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  color: #00a603;
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
`;

// ButtonContainer
// OtpFormContainer
